import * as types from './types';

const BACKEND_API = 'BACKEND_API';

export const creatGrossReciepts = data => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: '/portal_gross_receipts/',
    ...types.CREATE_GROSS_RECIEPTS
  }
});

export const editGrossReciepts = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/portal_gross_receipts/${id}/`,
    data,
    ...types.CREATE_GROSS_RECIEPTS
  }
});

export const getGrossReciepts = page => ({
  type: BACKEND_API,
  payload: {
  method: 'get',
  url: `/portal_gross_receipts/?${page ? 'page=' : ''}${page || ''}`,
    ...types.GET_GROSS_RECIEPTS
  }
});
export const getGrossRecieptDetail = id => ({
  type: BACKEND_API,
  payload: {
  method: 'get',
  url: `/portal_gross_receipts/${id}/`,
    ...types.GET_GROSS_RECIEPT_DETAIL
  }
});

export const getContracts = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
  url: '/portal_gross_receipts/get_contracts/',
    ...types.GET_CONTRACTS
  }
});

export const clearAction = () => ({
  type: types.GROSS_RECIEPTS_CLEAR_ACTION
});
